module.exports = __webpack_public_path__ + "static/media/logo.135acea1.png";